import { Box, Button } from "@mui/material";
import styled from "styled-components";

export const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
`;

export const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
`;

export const HeaderBox = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background-color: 'red';
`;

export const DetailsBox = styled(Box)`
  display: flex;
  gap: 1rem;
  margin-bottom: 20px;
`;

export const DetailItem = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
`;

export const BoldText = styled.p`
  font-weight: bold;
  color: #7c7c7c;
`;
